import LoginComponent from '@/components/login-component';
import { useTranslations } from 'next-intl';

const Forgot = () => {
  const t = useTranslations('Pages.Forgot');
  return <LoginComponent title={t('forgot_pwd')} view="forgotten_password" />;
};

export default Forgot;
